export class Limit {
	private max: string = "0";
	private min: string = "0";
	private defaults: string[] = [];

	public getMax(): number {
		return +this.max;
	}

	public setMax(value: number): void {
		this.max = "" + value;
	}

	public getMin(): number {
		return +this.min;
	}

	public setMin(value: number): void {
		this.min = "" + value;
	}

	public getDefaults(): number[] {
		return this.defaults.map((s) => +s);
	}

	public setDefaults(values: string[]): void {
		this.defaults = values;
	}
}
